import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

export interface SelectExcelSheetsResponse {
  data?: {
    status: 'success' | 'error';
    excel_object_key: string;
    converted: {
      sheet: string;
      csv_object_key: string;
    }[];
  };
  detail?: string;
}

interface SelectExcelSheetsProps {
  collectionId: string;
  excelObjectKey: string;
  sheets: string[];
  orgId?: string;
  rowLimit?: number;
}

export const selectExcelSheets = async ({
  collectionId,
  excelObjectKey,
  sheets,
  orgId,
  rowLimit,
}: SelectExcelSheetsProps): Promise<SelectExcelSheetsResponse> => {
  const resolvedOrgId = orgId || useOrgStore.getState().currentOrg?.orgid;

  if (!resolvedOrgId) {
    throw new Error('Organization ID is required');
  }

  if (!collectionId) {
    throw new Error('Collection ID is required');
  }

  if (!excelObjectKey) {
    throw new Error('Excel object key is required');
  }

  const queryString =
    typeof rowLimit === 'number' ? `?row_limit=${rowLimit}` : '';

  const response = await apiRequest<SelectExcelSheetsResponse>({
    url: `/uploads/${resolvedOrgId}/${collectionId}/excel-sheet-selection${queryString}`,
    method: 'POST',
    target: 'platform',
    body: {
      excel_object_key: excelObjectKey,
      sheets,
    },
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to submit sheet selection',
    };
  }

  return response as SelectExcelSheetsResponse;
};
